import axios from 'axios';
import store from '@/store/store'

export default () => {
  return axios.create({
    // baseURL: 'https://www.nxtagro.io/',
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  })
}
